<template>
  <v-list-item
    @click="goTo()"
    :class="{ 'pl-8': this.$vuetify.breakpoint.xsOnly, 'pl-14': !this.$vuetify.breakpoint.xsOnly }"
  >
    <v-list-item-icon
      v-if="pageIconURL || pageIcon"
      class="mx-0 px-0 align-center icon-container"
      style="background-color: rgba(255, 255, 255, 0.3);"
    >
      <v-img v-if="pageIconURL" class="icon-container" :src="pageIconURL" contain />
      <v-icon v-else class="icon-container">{{ pageIcon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-content :class="{ 'mx-4' : pageIconURL || pageIcon }">
      <v-list-item-title :class="{ 'H4': this.$vuetify.breakpoint.xsOnly, 'H1': !this.$vuetify.breakpoint.xsOnly }" color="white">{{ pageTitle }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
import router from '@/router'
import routeNames from '@/router/routes'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { mapGetters } from 'vuex'
import { pageTypes, preconfiguredPageRoutes } from '@/config'

export default {
  props: {
    page: Object,
  },
  computed: {
    ...mapGetters({ 
      authStatus: 'auth/authStatus',
      authToken: 'auth/authToken',
    }),
    pageTitle () {
      const { page, preconfiguredPage } = this.page
      let title = null
      if (page) {
        switch (page.type) {
        case pageTypes.LINK:
          title = getTextValue(page.pageSpecific.button.title)
          break
        case pageTypes.SERVICE:
          title = getTextValue(page.pageSpecific.title)
          break
        case pageTypes.CONTENT:
          title = getTextValue(page.pageSpecific.title)
          break
        case pageTypes.NAVIGATION:
          title = getTextValue(page.pageSpecific.title)
          break
        default:
          break
        }
      } else if (preconfiguredPage) {
        title = getTextValue(preconfiguredPage.title)
      }
      return title
    },
    pageIcon () {
      const { page, preconfiguredPage } = this.page
      let icon = null
      if (page) {
        icon = page.icon
      } else if (preconfiguredPage) {
        icon = preconfiguredPage.icon
      }
      return icon
    },
    pageIconURL () {
      const { page, preconfiguredPage } = this.page
      let icon = null
      if (page) {
        icon = page.iconUrl
      } else if (preconfiguredPage) {
        icon = preconfiguredPage.iconUrl
      }
      return icon
    },
    
    pageUrl () {
      const { page, preconfiguredPage } = this.page
      let url = null
      if (page) {
        switch (page.type) {
        case pageTypes.LINK:
          url = page.pageSpecific.button.url
          break
        default:
          break
        }
      } else if (preconfiguredPage) {
        url = preconfiguredPageRoutes[preconfiguredPage.pageName]
      }
      return url
    },
  },
  methods: {
    goTo () {
      const { page, preconfiguredPage } = this.page
      if (!this.pageUrl) {
        this.$store.commit('pages/setPage', page)
        router.push({ name: routeNames.page_details.name, params: { pageId: page.id }})
        return
      } else {
        if (this.pageUrl.startsWith('http')) {
          if (this.authenticated && !this.authStatus) {
            router.push({ name:'login', query: { ['next-url']: this.pageUrl }})
          } else {
            if (this.pageUrl && this.authenticated) {
              const url = `${ this.pageUrl }?x-api-key=${ this.authToken }`
              window.open(url, '_blank')
            } else {
              window.open(this.pageUrl, '_blank')
            }
          }
        } else {
          if (!!routeNames[this.pageUrl]) {
            router.push({ name: this.pageUrl })
          } else {
            router.push({ path: this.pageUrl })
          }
        }
      }
    },
  },
}
</script>
<style scoped>
  .icon-container {
    width: 34px;
    height: 34px !important;
    border-radius: 50%;
    background-color: rgba(var(--v-primary-lighten1-rgb), 0.2);
  }
</style>